import { f7 } from "framework7-react";

export const AppInterface = {
  // Android 환경인지 판별
  isAndroid() {
    return navigator.userAgent.match(/Android/i) != null;
  },
  // iOS 환경인지 판별
  isIOS() {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i) != null;
  },
  // Native에 데이터를 보내기위한 유틸 함수
  send(interfaceName: string, body: any) {
    if (AppInterface.isAndroid()) {
      try {
        (window as any).Android.getToken();
      } catch (error) {
        console.log(error);
      }
      // (window as any)[interfaceName]?.popOpened(body);
    } else if (AppInterface.isIOS()) {
      (window as any).webkit?.messageHandlers[interfaceName]?.postMessage(body);
    } else {
      console.error('No native APIs found.');
    }
  },
  // AppInterface.debug("something")을 입력하면 Native 콘솔창에 출력됩니다. console.log()와 같은 디버깅용 함수
  debug(message: any) {
    AppInterface.send('debug', { message: `${message}` });
  },
  // FCMToken을 응답받는 비동기 함수
  getFCMToken() {
    AppInterface.send('fcm', { cmd: 'getToken' });
    return new Promise((resolve) => (window as any).fcm.promises.push(resolve));
  },
  callQrScan() {
    AppInterface.send('startQrScanner', { cmd: `startQrScanner` });
    return new Promise((resolve) => (window as any).qrscan.promises.push(resolve));
  },
};

interface AlamofireRequest {
  url: string;
  method: 'get' | 'post' | 'put' | 'delete';
  headers: {
    [key: string]: string;
  };
  params: {
    [key: string]: string;
  };
}

interface AlamofireResponse {
  statusCode: string;
  data: string;
}

export const AlamofireInterface = {
  request(requestBody: AlamofireRequest) {
    const _event_id = `${Math.random()}`.slice(2);
    AppInterface.send('alamofire', { ...requestBody, _event_id });
    return new Promise<AlamofireResponse>((resolve, reject) => {
      (window as any).alamofire.appendEvent({
        _event_id,
        resolve,
        reject,
      });
    });
  },
};

interface IEvent {
  _event_id: string;
  resolve: (response: AlamofireResponse) => void;
  reject: (reason?: any) => void;
}

// Alamofire 요청에 대한 응답을 Native로 부터 콜백 응답 받기 위함
(window as any).alamofire = {
  events: [] as IEvent[],
  callback(_event_id: string, statusCode?: string, data?: string) {
    const event = ((window as any).alamofire.events as Array<IEvent>).find((each) => each._event_id === _event_id);
    if (event) {
      if (statusCode && data) event.resolve({ statusCode, data });
      else event.reject('failure');
    }
  },
  appendEvent(event: IEvent) {
    (window as any).alamofire.events.push(event);
  },
};

// FCM Token에 대한 요청을 Native로 부터 콜백 응답 받기 위함
(window as any).fcm = {
  promises: [] as Promise<string>[],
  callback(value) {
    (window as any).fcm.value = value;
    (window as any).fcm.promises.forEach((promise) => promise(value));
  },
};

// QR 스캐너 코드 받기
(window as any).qrscan = {
  promises: [] as Promise<string>[],
  callback(value) {
    (window as any).qrscan.value = value;
    (window as any).qrscan.promises.forEach((promise) => promise(value));
  },
};
